import React from 'react';
import { Typography } from '@mui/material';

const ResponsiveDialogTitle = ({ children }: React.PropsWithChildren<{}>) => {
  return <Typography variant='h6'>{children}</Typography>;
};

export default ResponsiveDialogTitle;
